import { Tabs, Tab, Box, Badge } from "@mui/material";
import { SyntheticEvent, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";

import SectionHeader from "../../../../util/component/SectionHeader";
import { JimpiTabPanel, TuiTabPanel, JimpiDisambiguationTabPanel } from "./components/tab-panels";

import { getCountDisuabiguationJimpi } from "../../api/services";

import { ImportPageTab, INTERVAL_BADGE_DISAMBIGUATION } from "./types";
import { ReactQueryKey } from "../../types";
import { jimpiFilterState, tuiFilterState } from "./recoil";
import { useSetRecoilState } from "recoil";

export const ImportPage = () => {

    const { t } = useTranslation('booking');

    const [searchParams, setSearchParams] = useSearchParams();

    const tabSearchParam = searchParams.get('tab');

    const [tab, setTab] = useState<ImportPageTab | null>(ImportPageTab.Jimpi);

    const setJimpiFilterParams = useSetRecoilState(jimpiFilterState);
    const setTuiFilterParams = useSetRecoilState(tuiFilterState);

    useEffect(() => {
        if(tabSearchParam && (Object.values(ImportPageTab) as string[]).includes(tabSearchParam)) {
            setTab(tabSearchParam as ImportPageTab);
        } else {
            setSearchParams(
                {
                    tab: ImportPageTab.Jimpi // default
                },{
                    replace: true
                }
            );
        }
    }, [tabSearchParam]);

    const handleTabsChange = useCallback((e: SyntheticEvent, newValue: ImportPageTab) => {
        setTab(newValue);
        setSearchParams(
            {
                tab: newValue
            }
        );
        
        setJimpiFilterParams(null);
        setTuiFilterParams(null);
        
    }, []);

    const countDisambiguationJimpiBadge = useQuery({
        queryKey: [ReactQueryKey.CountDisambiguationJimpiBadge],
        queryFn: getCountDisuabiguationJimpi,
        refetchInterval: INTERVAL_BADGE_DISAMBIGUATION
    });

    return (
        <>
            <SectionHeader
                title={t('label.import')}
            />
            <Box
                sx={{
                    borderBottom: 1,
                    borderColor: 'divider'
                }}
            >
                <Tabs
                    value={tab}
                    onChange={handleTabsChange}
                >
                    <Tab value={ImportPageTab.Jimpi} label={t('label.jimpi')} />
                    <Tab value={ImportPageTab.Tui} label={t('label.tui')} />
                    <Tab value={ImportPageTab.JimpiDisambiguation}  label={
                        <Badge badgeContent={countDisambiguationJimpiBadge?.data} color={'primary'}>
                            <Box sx={{ paddingRight : 2 }}>
                                {t('label.jimpiDisambiguation')}
                            </Box>

                        </Badge>
                    } />
                </Tabs>
            </Box>

            <Box p={3}>
                {tab === ImportPageTab.Jimpi && <JimpiTabPanel />}
                {tab === ImportPageTab.Tui && <TuiTabPanel />}
                {tab === ImportPageTab.JimpiDisambiguation && <JimpiDisambiguationTabPanel />}
            </Box>
        </>
    );
};

export default ImportPage;
